import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../../../content/css/RedflagComponent.css';
import 'react-dropdown-tree-select/dist/styles.css'
import CategoryOptionEditControl from '../CategoryOptionEditControl';

export default class I1RedflagComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redflags: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.refreshRedflags = this.refreshRedflags.bind(this);
    }

    componentDidMount() {
        this.refreshRedflags();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.category !== this.props.category) {
            this.refreshRedflags();
        }
    }

    refreshRedflags() {
        let redflags = [];
        redflags.push(this.props.getCategory("I1_1"));
        redflags.push(this.props.getCategory("I1_2"));
        redflags.push(this.props.getCategory("I1_3"));
        redflags.push(this.props.getCategory("I1_4"));
        redflags.push(this.props.getCategory("I1_5"));
        redflags.push(this.props.getCategory("I1_6"));
        redflags = redflags.filter(x => x);

        this.setState({ redflags });
    }

    handleChange(category, value) {
        let categoryTheme = Object.assign({}, category);
        categoryTheme.isActive = value;
        this.props.addOrUpdateCategoryTheme(categoryTheme);
    }

    getRedflags() {
        return this.state.redflags.map(redflag => (
            <div>
                <div className="panel-title-column">
                    <Link to={`/dashboard/themes/${this.props.packageId}/concept/${redflag.code}`}>{redflag.name}</Link>
                    <span>Toggle to flag this type of indemnity.</span>
                </div>
                <CategoryOptionEditControl isActive={redflag.isActive} onChange={(isActive) => this.handleChange(redflag, isActive)} />
                {redflag.code !== "I1_6" && < hr />}
            </div >
        ));
    }

    render() {
        return (
            <div className="I1-redflag">
                {this.getRedflags()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CategoryView/Redflag/I1RedflagComponent.js